import React from 'react'
import useHomeLinkMode from '../../../shared/hooks/useHomeLinkMode';
import useMobile from "../../../shared/hooks/useMobile"
import './section-promotional-banner.scss'

const SectionPromotionalBanner = ({ contentInfo }) => {

    const { homeLink } = useHomeLinkMode();
    const mobile = useMobile()

    return (
        <section className="f-m-promotional-banner">
            <div className="f-m-promotional-banner__content"
                onClick={() => { location.href = ((contentInfo.redireccionBoton.includes('https') || contentInfo.redireccionBoton.includes('www')) ? (contentInfo.redireccionBoton) : (homeLink + contentInfo.redireccionBoton)) }}
            >
                {contentInfo.imagen &&
                    <img
                        src={contentInfo.imagen[contentInfo.imagen.length > 1 ? (mobile ? 1 : 0) : 0].file.url}
                        alt={contentInfo.imagen[contentInfo.imagen.length > 1 ? (mobile ? 1 : 0) : 0].description}
                        className="f-m-promotional-banner__image"
                    />
                }
            </div>
        </section>
    )
}

export default SectionPromotionalBanner
